import * as PaddingViews from '../util/padding_views';
import React             from 'react';
import ReactDOM          from 'react-dom';


//  pop-up fatigue.
//  90% of Chrome permission requests are ignored.
//    -- https://twitter.com/lukew/status/922523903808770048
//
//  We have two issues here. A lot of people don't want to take action on the
//  permission request until they feel more comfortable in making a decision.
//  The browser's own permission UI is rather intrusive, and so they're
//  pressured into making a decision, good chance they'll deny the request.
//
//  Once denied, it's very hard to "un-deny". User won't be asked again, and
//  good luck finding the UI toggle.
//
//  Instead, we're going to show a banner at the top of the screen.  We can
//  style it to feel less intrusive.  And include a close button, so people can
//  dimiss it until they're ready to make a decision (temporarily, but as often
//  as they want).
//
//  Only when user clicks on the banner with the intent to enable desktop
//  notifications, do we have the browser ask for permission again.
//
//  This double opt-in to desktop notification UX pattern borrowed from Slack.
export default async function optIn() {
  const isShowing = !!document.querySelector('.b-notification-permission');
  if (isShowing)
    return false;

  const container  = document.createElement('div');
  const isAccepted = await new Promise(function(resolve) {
    const component = (
      <RequestPermissionBanner
        onAccept={() => {
          PaddingViews.remove(document.querySelector('.b-notification-permission'));
          resolve(true);
        }}
        onClose={() => {
          PaddingViews.remove(document.querySelector('.b-notification-permission'));
          resolve(false);
        }}
      />
    );
    ReactDOM.render(component, container, function() {
      document.body.appendChild(container);
      PaddingViews.add(document.querySelector('.b-notification-permission'));
    });
  });

  document.body.removeChild(container);
  return isAccepted;
}


function RequestPermissionBanner({ onAccept, onClose }) {
  return (
    <div className="b-notification-permission">
      <span>Broadly needs your permission to </span>
      <a className="b-notification-permission__accept" onClick={onAccept}>enable desktop notifications</a>
      <a className="b-notification-permission__close" onClick={onClose}>
        <i className="f7-icons">close_round</i>
      </a>
    </div>
  );
}
